import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import PartnersPanel from './PartnersPanel'
import DividerSection from './DividerSection'
import Cookies from 'universal-cookie'
import { shouldTranslateTo } from '../utils/utils'
import { getCurrencySign } from '../utils/utils'
import { decode } from 'html-entities'

import {
  Title,
  Subtitle,
  ContainerFlexColumn,
  PrimaryButton,
} from './Utils/CustomClasses'

const cookies = new Cookies()

const Container = styled.div``

const ContentWrapper = styled(ContainerFlexColumn)`
  background-color: ${({ color }) => (color ? color : '#fff')};
`

const PartnersCTA = styled(PrimaryButton)`
  background: white;
  color: #154549;
  padding: 16px 32px;
  font-size: 18px;

  &:hover {
    background: #f0f0f0;
  }

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`

const Partners = () => {
  const [pageText, setPageText] = React.useState([])
  const [pageText2, setPageText2] = React.useState([])
  const [currencySign, setCurrencySign] = useState('')
  const [translations, setTranslations] = useState({})

  useEffect(() => {
    const language = shouldTranslateTo()

    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('how-it-works-v3', language, setPageText)
    getPageText('profile-pay', language, setPageText2)

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(cookies.get('cV'))
      setCurrencySign(currencySignData.sign)
    }
    getCurrency()
  }, [])

  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const language = shouldTranslateTo()
        const response = await axios.get(`/api/page-text/partners/${language}`)

        // Transform the response data into an object with textId as key
        const translationsMap = response.data.reduce((acc, item) => {
          acc[item.textId] = item.text
          return acc
        }, {})
        setTranslations(translationsMap)
        console.log('Translations loaded:', translationsMap) // Debug log
      } catch (error) {
        console.error('Error fetching translations:', error)
      } finally {
      }
    }

    fetchTranslations()
  }, [])

  if (pageText.length === 0 || pageText2.length === 0 || !currencySign) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <Container>
      <ContentWrapper
        color={'#F6F0E6'}
        padding="4vh 15vw 6vh 15vw"
        paddingSm="4vh 5vw 6vh 5vw"
      >
        <PartnersPanel color={'#F6F0E6'} />
      </ContentWrapper>

      {/* Divider */}
      <DividerSection colorType={5} color={'#F6F0E6'} flip={false} />

      {/* CTA Section */}
      <ContainerFlexColumn
        center
        padding="8vh 15vw 10vh 15vw"
        paddingSm="7vh 5vw 10vh 5vw"
        background="#154549"
      >
        <Title
          color="#FFFFFF"
          size="46px"
          sizemd="40px"
          sizesm="38px"
          center
          margin="0 10vw 40px 10vw"
          marginmd="0 10vw 40px 10vw"
          marginsm="20px 0 40px 0"
        >
          {translations[76]
            ? decode(translations[76])
            : 'Want to Partner with Us?'}
        </Title>
        <Subtitle
          center
          weight="300"
          color="#FFFFFF"
          size="22px"
          sizemd="22px"
          sizesm="22px"
          margin="0 7vw 50px 7vw"
          marginsm="0 8px 40px 8px"
        >
          {translations[77] ? decode(translations[77]) : ''}
        </Subtitle>
        <a
          href="https://airtable.com/appy7ArTELVx6dUxz/pagxb939tNk5lVTns/form"
          target="_blank"
          rel="noopener noreferrer"
        >
          <PartnersCTA>
            {translations[78] ? decode(translations[78]) : 'Get in Touch'}
          </PartnersCTA>
        </a>
      </ContainerFlexColumn>
    </Container>
  )
}
export default Partners
